module.exports = __webpack_public_path__ + "static/img/ys3.f13ad98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ys3.png
// module id = NpT4
// module chunks = 1